module.exports = __webpack_public_path__ + "img/TailWing_Overview-TW_4.50151127.jpg";